// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"112":"book","297":"library","913":"library-page","942":"article"}[chunkId] + "." + {"112":"330177ef","297":"a5f0982e","913":"5a9b24ee","942":"9a9a99d9"}[chunkId] + ".css";
};